import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'
import { isNil } from 'lodash'

export const formatPercentage = (value: number | string): string =>
  isNil(value) || value === DEFAULT_PLACEHOLDER ? DEFAULT_PLACEHOLDER : `${value}%`
